import axios from "axios";
import EventBus from "./eventBus.js";
// console.log("process.env!", process.env);

const API = process.env.VUE_APP_API; //"https://api.tukbot.com/prod/tuk/"
const TUKAuthBase = "Bearer helloworld";
var TUKAuth = TUKAuthBase; // use default then add uuid later
var TUKConfig = { headers: { Authorization: TUKAuth } }; //'withCredentials': true }, };

// add timestamp on end of URL to force it to evade any local caching
function tsAdd(url) {
  var ts = new Date().getTime();
  if (!url.includes("?")) {
    return url + `?ts=${ts}`; // create query
  }
  return url + `&ts=${ts}`; // append to query
}

// axios.defaults.headers = {
// Authorization: TUKAuth,
// "Access-Control-Max-Age": 0,
// "Cache-Control": "no-cache",
// Pragma: "no-cache",
// Expires: "0",
// };

var api = {
  updateTUKAuthWithUUID(uuid) {
    if (!TUKAuth.includes(uuid)) TUKAuth = `${TUKAuth}|${uuid}`;
    TUKConfig = { headers: { Authorization: TUKAuth } };
  },

  lineUsersGet(lineUserID, cookies) {
    var url = API + `line_users/${lineUserID}`;
    var start = Date.now();
    axios
      .get(url, TUKConfig)
      .then(resp => {
        console.log("TUK API SUCCESS", resp);
        cookies.set("user", resp.data);
        localStorage.user = JSON.stringify(resp.data);
        localStorage.user_id = resp.data.user.id;
        localStorage.lineName = resp.data.user_source.source_user_name;
        EventBus.$emit("USER", resp.data);
      })
      .catch(error => {
        console.log("TUK API ERR:" + error);
        EventBus.$emit("DEBUG", `lineUsersGet error: ${error}`);
      })
      .finally(() => {
        var ms = (Date.now() - start) / 1000;
        console.log("tuk/line_users response time", ms);
      });
  },

  // same as lineUsersGet
  vuexUsersGet(lineUserID) {
    var url = API + `line_users/${lineUserID}`;
    return axios.get(url, TUKConfig);
  },
  fbUsersGet(fbUserID) {
    var url = API + `fb_users/${fbUserID}`;
    return axios.get(url, TUKConfig);
  },
  smsUsersGet(mobileNumber) {
    var url = API + `sms_users/${mobileNumber}`;
    return axios.get(url, TUKConfig);
  },
  usersGet(source, id, uuid) {
    // sources: fb, sms, line
    var url = API + `${source}_users/${id}?uuid=${uuid}`;
    return axios.get(url, TUKConfig);
  },
  usersGetNew(userID) {
    // used by profile page to update user
    var url = API + `users/${userID}`;
    return axios.get(url, TUKConfig);
  },
  usersGetInfo(userID) {
    // for super user to lookup user info
    var url = API + `users/${userID}?info=true`;
    return axios.get(url, TUKConfig);
  },
  appleUserGet(id, uuid) {
    // hack for apple
    var url = API + `users/${id}?uuid=${uuid}`;
    return axios.get(url, TUKConfig);
  },
  userSourcesPost(data) {
    var url = API + `user_sources`;
    return axios.post(url, data, TUKConfig);
  },
  magicLoginsGet() {
    var url = API + `magic_login/recent`;
    return axios.get(url, TUKConfig);
  },
  createTukExpressFromPastOrder(data) {
    var url = API + `helpers/create_tuk_express_from_past_order`;
    return axios.post(url, data, TUKConfig);
  },
  createShopPost(data) {
    var url = API + `helpers/create_shop`;
    return axios.post(url, data, TUKConfig);
  },
  isShopOpen(handle) {
    var ts = new Date().getTime();
    var url = API + `helpers/shop_open?handle=${handle}&ts=${ts}`; // timestamp hack
    return axios.get(url, TUKConfig);
  },
  isShopOpenByID(businessID) {
    var ts = new Date().getTime();
    var url = API + `helpers/shop_open?id=${businessID}&ts=${ts}`; // timestamp hack
    return axios.get(url, TUKConfig);
  },
  blobsGetTranslationsByParent(parentID) {
    var url = API + `blob?type=translations&id=${parentID}`;
    return axios.get(url, TUKConfig);
  },
  blobsGetList(page, region) {
    // get list for page and region (could add ALL flag to get is_deleted lists also)
    var url = API + `blob/active?type=page&page=${page}&region=${region}`;
    return axios.get(url, TUKConfig);
  },
  blobsGetWorkflow(workflowID) {
    var url = API + `blob/${workflowID}?type=workflow`;
    return axios.get(url, TUKConfig);
  },
  blobsGetDigitalMenu(workflowID) {
    var url = API + `blob/${workflowID}?type=workflow&blob_type=digital_menu`;
    return axios.get(url, TUKConfig);
  },
  blobsPost(data) {
    var url = API + `blob`;
    return axios.post(url, data, TUKConfig);
  },
  blobsDelete(id) {
    var url = API + `blob/${id}`;
    return axios.delete(url, TUKConfig);
  },
  checkUserUUID(userID, uuid) {
    var url = API + `users/${userID}?uuid=${uuid}&check=true`;
    return axios.get(url, TUKConfig);
  },
  logoutPatch(userID, notificationToken) {
    var url = API + `logout/${userID}`;
    var data = { notification_token: notificationToken };
    return axios.patch(url, data, TUKConfig);
  },

  // same as lineUsersGet
  vuexUsersPatch(userID, data) {
    var url = API + `users/${userID}`;
    return axios.patch(url, data, TUKConfig);
  },
  // same as above
  usersPatch(userID, data) {
    var url = API + `users/${userID}`;
    return axios.patch(url, data, TUKConfig);
  },
  usersPatchMigrate(data) {
    var url = API + `users/${data.user_id}?action=migrate`;
    return axios.patch(url, data, TUKConfig);
  },
  usersPatchSettings(userID, data) {
    var url = API + `users/${userID}?action=settings`;
    return axios.patch(url, data, TUKConfig);
  },
  rolesPatch(roleID, data) {
    var url = API + `roles/${roleID}`;
    return axios.patch(url, data, TUKConfig);
  },
  devicesPost(uuid, data) {
    var url = API + `devices/${uuid}`;
    return axios.post(url, data, TUKConfig);
  },
  promoCodeGet(code) {
    var url = API + `promo/${code}`;
    return axios.get(url, TUKConfig);
  },
  deliveryGetPrice() {
    var query = `pickup=10.123,103.123&dropoff=10.231,103.213&type=express`;
    var url = API + `delivery/price_check?${query}`;
    return axios.get(url, TUKConfig);
  },
  directionsGet(p, d) {
    var p1 = `${p.lat},${p.lon}`;
    var p2 = `${d.lat},${d.lon}`;
    var url = API + `directions?origin=${p1}&destination=${p2}`;
    return axios.get(url, TUKConfig, { timeout: 1500 }); //, { timeout: 1500 });
  },
  // function magicLoginPost() {
  magicLoginPost(data) {
    var url = API + `magic_login`;
    return axios.post(url, data, TUKConfig);
  },

  magicLoginGet(magicLoginID) {
    var url = API + `magic_login/${magicLoginID}`;
    return axios.get(url, TUKConfig);
  },
  magicLoginGetVerify(magicLoginID, code) {
    var url = API + `magic_login/${magicLoginID}?code=${code}`;
    return axios.get(url, TUKConfig);
  },
  magicLoginGetResend(magicLoginID, notificationToken) {
    var url = API + `magic_login/${magicLoginID}?resend=${notificationToken}`;
    return axios.get(url, TUKConfig);
  },
  logsPost(data) {
    var url = API + `logs`;
    return axios.post(url, data, TUKConfig);
  },
  emailPost(data) {
    var url = API + `email`;
    return axios.post(url, data, TUKConfig);
  },
  emailLoginPost(data) {
    var url = API + `email/login`;
    return axios.post(url, data, TUKConfig);
  },
  devicesGetByUserID(userID) {
    var url = API + `devices?user_id=${userID}`;
    return axios.get(url, TUKConfig);
  },
  rolesGet(userID) {
    var url = API + `roles/${userID}`;
    return axios.get(url, TUKConfig);
  },
  rolesGetByBusinessID(businessID) {
    var url = API + `roles?business_id=${businessID}`;
    return axios.get(url, TUKConfig);
  },
  rolesGetByWorkflowID(workflowID) {
    var url = API + `roles?workflow_id=${workflowID}`;
    return axios.get(url, TUKConfig);
  },
  rolesGetByWorkflowIDAndRoleName(workflowID, roleName) {
    var url = API + `roles?workflow_id=${workflowID}&role_name=${roleName}`;
    return axios.get(url, TUKConfig);
  },
  rolesPost(locale, data) {
    var sendSMS = data.send_sms || "yes"; // default yes
    var url = API + `roles?locale=${locale}&sms=${sendSMS}`;
    return axios.post(url, data, TUKConfig);
  },
  rolesDelete(roleID) {
    var url = API + `roles/${roleID}`;
    return axios.delete(url, TUKConfig);
  },
  businessesPost(data) {
    var url = API + `businesses`;
    return axios.post(url, data, TUKConfig);
  },
  businessesPatch(businessID, data) {
    var url = API + `businesses/${businessID}`;
    return axios.patch(url, data, TUKConfig);
  },
  businessesPatchActive(data) {
    var url = API + `businesses/active`;
    return axios.patch(url, data, TUKConfig);
  },
  recommendationsGet(type, page, userID) {
    var ts = new Date().getTime();
    var url =
      API + `recommendations/${type}?page=${page}&user_id=${userID}&ts=${ts}`; // timestamp hack
    return axios.get(url, TUKConfig);
  },
  eateriesGet(coords) {
    var ts = new Date().getTime();
    var url = API + `businesses?type=eatery&ts=${ts}`; // timestamp hack
    if (coords) url = url + `&coords=${coords}`; // pass coords to get nearby
    return axios.get(url, TUKConfig);
  },
  martsGet(coords) {
    var ts = new Date().getTime();
    var url = API + `businesses?type=mart&ts=${ts}`; // timestamp hack
    if (coords) url = url + `&coords=${coords}`; // pass coords to get nearby
    return axios.get(url, TUKConfig);
  },
  newShopsGet(coords) {
    var ts = new Date().getTime();
    var url = API + `businesses?type=new_shops&coords=${coords}&ts=${ts}`; // timestamp hack
    return axios.get(url, TUKConfig);
  },
  transportGet(coords) {
    var ts = new Date().getTime();
    var url = API + `businesses?type=transport&ts=${ts}`; // actually workflows...with businesses attached
    if (coords) url = url + `&coords=${coords}`; // pass coords to get nearby
    return axios.get(url, TUKConfig);
  },
  userStopsGet(userID, coords) {
    var url = API + `stops?user=${userID}&n=20`;
    if (coords) url = url + `&coords=${coords}`; // pass coords to get nearby
    return axios.get(url, TUKConfig);
  },
  businessesGetByTypeForSuperuser(businessType) {
    var url = API + `businesses/superuser?type=${businessType}`; // for super user only
    return axios.get(url, TUKConfig);
  },
  businessesGet(coords) {
    var url = API + `businesses`; // otherwise get all (2020-09-01 don't use get all, use type above)
    if (coords) url = url + `?coords=${coords}`; // pass coords to get nearby
    return axios.get(url, TUKConfig);
  },
  businessesGetSingle(ID) {
    var ts = new Date().getTime();
    var url = API + `businesses/${ID}?ts=${ts}`;
    return axios.get(url, TUKConfig);
  },
  getBusinessAndWorkflows(ID) {
    var ts = new Date().getTime();
    var url = API + `helpers/get_business_and_workflows?id=${ID}&ts=${ts}`;
    return axios.get(url, TUKConfig);
  },
  businessesGetWorkflows(businessID, workflowType) {
    var ts = new Date().getTime();
    var url =
      API + `businesses/${businessID}?workflow_type=${workflowType}&ts=${ts}`;
    return axios.get(url, TUKConfig);
  },
  businessesDelete(ID) {
    var url = API + `businesses/${ID}`;
    return axios.delete(url, TUKConfig);
  },
  businessesReplicate(ID) {
    var url = API + `helpers/replicate_business?id=${ID}`;
    return axios.get(url, TUKConfig);
  },
  getPausedShops() {
    var url = API + `helpers/get_paused_shops`;
    return axios.get(url, TUKConfig);
  },
  getActiveBasketsCount() {
    var url = API + `analytics/active_baskets_count`;
    return axios.get(url, TUKConfig);
  },
  getCommerceOrderStats() {
    var url = API + `helpers/get_commerce_order_stats`;
    return axios.get(url, TUKConfig);
  },
  forceChangeTransactionState(data) {
    var url = API + `helpers/force_change_transaction_state`;
    return axios.patch(url, data, TUKConfig);
  },
  getCommerceOrderViewingHistory(transactionID) {
    var url =
      API +
      `helpers/get_commerce_order_viewing_history?transaction=${transactionID}`;
    return axios.get(url, TUKConfig);
  },
  getCommerceAgentsInfo(workflowID) {
    var url = API + `helpers/get_commerce_agents_info?workflow=${workflowID}`;
    return axios.get(url, TUKConfig);
  },
  getActiveDeliveryDrivers() {
    var url = API + `helpers/get_active_delivery_drivers`;
    return axios.get(url, TUKConfig);
  },
  deliveryFleetStats() {
    var url = API + `helpers/delivery_fleet_stats`;
    return axios.get(url, TUKConfig);
  },
  superuserStats() {
    var url = API + `helpers/superuser_stats`;
    return axios.get(url, TUKConfig);
  },
  commerceStats(businessID) {
    var url = API + `helpers/commerce_stats?id=${businessID}`;
    return axios.get(url, TUKConfig);
  },
  commerceOrderHistoryCountsForBusiness(businessID) {
    var url = API + `helpers/commerce_order_history_counts?id=${businessID}`;
    return axios.get(url, TUKConfig);
  },
  commerceOrderHistoryForPeriod(businessID, period) {
    var url =
      API +
      `helpers/commerce_order_history_period?id=${businessID}&period=${period}`;
    return axios.get(url, TUKConfig);
  },
  workflowsReplicate(oldID, newID) {
    var url = API + `helpers/copy_commerce_blobs?old=${oldID}&new=${newID}`;
    return axios.get(url, TUKConfig);
  },
  overwriteCommerceBlobs(fromID, toID) {
    var url =
      API + `helpers/overwrite_commerce_blobs?from=${fromID}&to=${toID}`;
    return axios.get(url, TUKConfig);
  },
  usersDelete(ID) {
    var url = API + `users/${ID}`;
    return axios.delete(url, TUKConfig);
  },
  workflowsPost(data) {
    var url = API + `workflows`;
    return axios.post(url, data, TUKConfig);
  },
  workflowsPatch(workflowID, data) {
    console.log("workflowsPatch", workflowID, data);
    var url = API + `workflows/${workflowID}`;
    return axios.patch(url, data, TUKConfig);
  },
  workflowsPatchData(data) {
    var url = API + `workflows/data`;
    return axios.patch(url, data, TUKConfig);
  },
  workflowsPatchGeometry(data) {
    var url = API + `workflows/geometry`;
    return axios.patch(url, data, TUKConfig);
  },
  // workflowsPatch(data) {
  //     var url = API + `workflows`
  //     return axios.patch(url, data, TUKConfig)
  // },
  workflowsGetCommerceDelivery(workflowID) {
    var ts = new Date().getTime();
    var url = API + `workflows?commerce_delivery=${workflowID}&ts=${ts}`;
    return axios.get(url, TUKConfig);
  },
  workflowsGet(businessID) {
    var ts = new Date().getTime();
    var url = API + `workflows/${businessID}?ts=${ts}`; // timestamp hack
    return axios.get(url, TUKConfig);
  },
  workflowsGetAll(coords) {
    var url = API + `workflows`;
    if (coords) url = url + `?coords=${coords}`;
    return axios.get(url, TUKConfig);
  },
  workflowsGetByType(workflowType) {
    var url = API + `workflows?workflow_type=${workflowType}`;
    return axios.get(url, TUKConfig);
  },
  workflowsGetByID(id) {
    var url = API + `workflows?id=${id}`;
    return axios.get(url, TUKConfig);
  },
  stripePost(postType, data) {
    var url = API + `stripe/${postType}`;
    return axios.post(url, data, TUKConfig);
  },
  fraudPromoCancellations(userID) {
    var url = API + `fraud/promo_cancellations?user_id=${userID}`;
    return axios.get(url, TUKConfig);
  },
  transactionsReplicate(transactionID, date) {
    var url = API + `transactions/${transactionID}?replicate=${date}`;
    return axios.post(url, null, TUKConfig);
  },
  transactionsPost(data) {
    var url = API + `transactions`;
    return axios.post(url, data, TUKConfig);
  },
  transactionsPostNearby(data, coords) {
    var url = API + `transactions?coords=${coords}`;
    return axios.post(url, data, TUKConfig);
  },
  transactionsTriggerMoreSiilors(transactionID) {
    var url = API + `transactions?trigger_more_siilors=${transactionID}`;
    return axios.get(url, TUKConfig);
  },
  transactionsTriggerInactiveSiilors(transactionID) {
    var url = API + `transactions?trigger_inactive_siilors=${transactionID}`;
    return axios.get(url, TUKConfig);
  },
  transactionsGetByID(ID) {
    var url = API + `transactions?transaction_id=${ID}`;
    return axios.get(url, TUKConfig); // get sii lor transactions
  },
  transactionsGetByWorkflowType(type, offset, status) {
    var url =
      API +
      `transactions?workflow_type=${type}&offset=${offset}&status=${status}`;
    return axios.get(url, TUKConfig); // get sii lor transactions
  },
  transactionsGetByWorkflowID(workflowID) {
    var url = API + `transactions?workflow_id=${workflowID}`;
    return axios.get(url, TUKConfig); // old api for driver, now used for stats modal
  },
  transactionsGetOngoingByWorkflowID(workflowID) {
    var url = API + `transactions?workflow_id=${workflowID}&type=ongoing`;
    return axios.get(url, TUKConfig); // commerce agent ongoing orders
  },
  transactionsGetPastByWorkflowID(workflowID) {
    var url = API + `transactions?workflow_id=${workflowID}&type=past`;
    return axios.get(url, TUKConfig); // commerce agent past orders
  },
  transactionsGetOngoingFleet(workflowID) {
    var url = API + `fleet/transactions?workflow_id=${workflowID}&type=ongoing`;
    return axios.get(url, TUKConfig); // fleet dispatcher ongoing orders
  },
  transactionsGetOngoingLogistics(workflowID) {
    var url =
      API + `logistics/transactions?workflow_id=${workflowID}&type=ongoing`;
    return axios.get(url, TUKConfig); // logistics agent ongoing orders
  },
  transactionsGetPastLogistics(workflowID) {
    var url =
      API + `logistics/transactions?workflow_id=${workflowID}&type=past`;
    return axios.get(url, TUKConfig); // commerce agent ongoing orders
  },
  transactionsGetLogisticsOrder(ID) {
    var url = API + `logistics/transaction?id=${ID}`;
    return axios.get(url, TUKConfig);
  },
  incrementCommerceOrder(ID) {
    // var url = API + `commerce/transaction?id=${ID}`
    var url = API + `commerce/increment_order_number?id=${ID}`;
    return axios.get(url, TUKConfig);
  },
  incrementCallShopCounter(ID) {
    var url = API + `commerce/increment_call_shop?id=${ID}`;
    return axios.get(url, TUKConfig);
  },
  assignDriverToCommerceOrder(transactionID, driverPhoneNumber) {
    var data = { phone_number: driverPhoneNumber };
    var url = API + `commerce/assign_driver?id=${transactionID}`; // data: {driver: "+66..."}
    return axios.patch(url, data, TUKConfig);
  },
  changeCommerceOrderToAutoconfirm(transactionID) {
    var url = API + `commerce/change_to_autoconfirm?id=${transactionID}`; // data: {driver: "+66..."}
    return axios.patch(url, null, TUKConfig);
  },
  transactionsGetRideOrder(ID) {
    var url = API + `ride/transaction?id=${ID}`;
    return axios.get(url, TUKConfig);
  },
  transactionsGetCommerceOrder(ID) {
    var url = API + `commerce/transaction?id=${ID}`;
    return axios.get(tsAdd(url), TUKConfig);
  },
  transactionsGetCommerceOrderForAgent(ID) {
    var url = API + `commerce/transaction?id=${ID}&agent=true`;
    return axios.get(tsAdd(url), TUKConfig);
  },
  transactionsGetPartialCommerceOrderForAgent(ID) {
    var url = API + `commerce/transaction?id=${ID}&mode=agent_partial`;
    return axios.get(tsAdd(url), TUKConfig);
  },
  transactionsGetCommerceDelivery(ID) {
    var url = API + `commerce/delivery?id=${ID}`;
    return axios.get(tsAdd(url), TUKConfig);
  },
  // transactionsGetOngoingByBusinessID(businessID) {
  //     var url = API + `transactions?workflow_id=${businessID}&type=ongoing`
  //     return axios.get(url, TUKConfig) // commerce agent ongoing orders
  // },
  // transactionsGetPastByBusinessID(businessID) {
  //     var url = API + `transactions?workflow_id=${businessID}&type=past`
  //     return axios.get(url, TUKConfig) // commerce agent past orders
  // },
  transactionsGetByDeliveryWorkflowID(workflowID) {
    var url = API + `transactions?workflow_id=${workflowID}&type=delivery`;
    return axios.get(url, TUKConfig); // used for delivery history modal
  },
  transactionsGetByWorkflowIDAndUserID(workflowID, userID, force) {
    var url =
      API +
      `transactions?workflow_id=${workflowID}&user_id=${userID}&force=${force}`;
    return axios.get(tsAdd(url), TUKConfig); // new api for driver
  },
  transactionsGetByWorkerID(userID) {
    var url = API + `transactions?worker_id=${userID}`;
    return axios.get(url, TUKConfig); // new api for driver
  },
  transactionsGetByUserID(userID) {
    var url = API + `transactions?user_id=${userID}`;
    return axios.get(url, TUKConfig); // customer active
  },
  getDriverStats(driverID) {
    var url = API + `helpers/driver_stats?driver_id=${driverID}`;
    return axios.get(tsAdd(url), TUKConfig); // customer active
  },
  getRecentDriverRemitTransactions(driverID) {
    var url = API + `remit?driver=${driverID}&type=recent`;
    return axios.get(tsAdd(url), TUKConfig); // customer active
  },
  getRecentlyFailedCustomerCommerceOrders(userID) {
    var query = `?type=recently_failed&user_id=${userID}`;
    var url = API + `commerce/transactions` + query;
    return axios.get(url, TUKConfig); // customer active
  },
  transactionsGetRecentByUserID(userID) {
    var url = API + `transactions?user_id=${userID}&type=recent`;
    return axios.get(url, TUKConfig); // customer history
  },
  transactionsGetOngoingByUserID(userID) {
    var url = API + `transactions?user_id=${userID}&type=ongoing`;
    return axios.get(url, TUKConfig); // customer ongoing (new)
  },
  transactionsGetRelevantToUserID(userID, offset) {
    var url =
      API + `transactions?user_id=${userID}&type=relevant&offset=${offset}`;
    return axios.get(url, TUKConfig); // relevant, could be driver or customer, past or ongoing
  },
  transactionsGetStatsForUserID(userID) {
    var url = API + `transactions?user_id=${userID}&type=stats`;
    return axios.get(url, TUKConfig);
  },
  transactionsGetTopShopsForUserID(userID) {
    var url = API + `transactions?user_id=${userID}&type=top_shops`;
    return axios.get(url, TUKConfig);
  },
  transactionsPatch(transactionID, data) {
    var url = API + `transactions/${transactionID}`;
    return axios.patch(url, data, TUKConfig);
  },
  transactionsDelete(ID) {
    var url = API + `transactions/${ID}`;
    return axios.delete(url, TUKConfig);
  },
  transactionsUndelete(ID) {
    var url = API + `transactions/${ID}?undelete=true`;
    return axios.delete(url, TUKConfig);
  },
  validationGet() {
    var url = API + `validation`;
    return axios.get(url, TUKConfig);
  },
  userStatesPost(data) {
    var url = API + `user_states`;
    return axios.post(url, data, TUKConfig);
  },
  broadcastMessagePost(data) {
    var url = API + `message?type=broadcast`;
    return axios.post(url, data, TUKConfig);
  },
  workflowMessagePost(data) {
    var url = API + `message?type=workflow`;
    return axios.post(url, data, TUKConfig);
  },
  userMessagePost(data) {
    var url = API + `message`;
    return axios.post(url, data, TUKConfig);
  },
  userMessagesGet(userID) {
    var url = API + `message?user_id=${userID}`;
    return axios.get(url, TUKConfig);
  },
  userMessagesPatch(messageID) {
    var url = API + `message/${messageID}`; // simply mark read
    return axios.patch(url, null, TUKConfig);
  },
  userMessagesDelete(messageID) {
    var url = API + `message/${messageID}`; // simply mark read
    return axios.delete(url, TUKConfig);
  },
  userAddressesDelete(addressID) {
    var url = API + `user_addresses/${addressID}`;
    return axios.delete(url, TUKConfig);
  },
  userAddressesPost(data) {
    var url = API + `user_addresses`;
    return axios.post(url, data, TUKConfig);
  },
  userAddressesPatch(data) {
    var url = API + `user_addresses`;
    return axios.patch(url, data, TUKConfig);
  },
  userAddressesGetDelivery(phoneNumber) {
    var url = API + `user_addresses?phone_number=${phoneNumber}`;
    return axios.get(url, TUKConfig);
  },
  userAddressesGet(userID) {
    var url = API + `user_addresses/${userID}`;
    return axios.get(url, TUKConfig);
  },
  commerceInvoicesPost(data) {
    var url = API + `invoices?type=commerce`;
    return axios.post(url, data, TUKConfig);
  },
  commerceInvoicesGet(workflowID) {
    var url = API + `invoices?workflow=${workflowID}`;
    return axios.get(url, TUKConfig);
  },
  logisticsFleetGet(businessID) {
    var url = API + `logistics/fleet?business_id=${businessID}`; // quick hack for demo
    return axios.get(url, TUKConfig);
  },
  shortLinkPost(data) {
    var url = API + `short_link`;
    return axios.post(url, data, TUKConfig);
  },
  shortLinkGet(shortID) {
    var url = API + `short_link/${shortID}`;
    return axios.get(url, TUKConfig);
  },
  shortLinkPatch(data) {
    var url = API + `short_link`;
    return axios.patch(url, data, TUKConfig);
  },
  searchAutocomplete(text) {
    var url = API + `autocomplete?search=${text}`;
    return axios.get(url, TUKConfig);
  },
  businessAutocomplete(text) {
    var url = API + `autocomplete?business=${text}`;
    return axios.get(url, TUKConfig);
  },
  searchMenuItems(text) {
    var url = API + `search/menu_items?text=${text}`;
    return axios.get(url, TUKConfig);
  },
  userAutocomplete(text) {
    var url = API + `autocomplete?user=${text}`;
    return axios.get(url, TUKConfig);
  },
  createDriverRemit(date) {
    var url = API + `helpers/create_daily_driver_remit?date=${date}`;
    return axios.post(url, null, TUKConfig);
  },
  readyDriverRemit(date) {
    var url = API + `helpers/ready_daily_driver_remit?date=${date}`;
    return axios.patch(url, null, TUKConfig);
  },
  driverAutocomplete(text) {
    var url = API + `autocomplete?driver=${text}`;
    return axios.get(url, TUKConfig);
  },
  businessWorkflowsAutocomplete(workflowType) {
    var url = API + `autocomplete?workflow=${workflowType}`;
    return axios.get(url, TUKConfig);
  },
  driversByWorkflowGet(workflowID) {
    var url = API + `drivers?workflow=${workflowID}`;
    return axios.get(url, TUKConfig);
  },
  driverWorkflowsAutocomplete(workflowID) {
    var url = API + `autocomplete?driver_workflow=${workflowID}`;
    return axios.get(url, TUKConfig);
  },
  deliveryWorkflowsAutocomplete(workflowID) {
    var url = API + `autocomplete?delivery_workflow=${workflowID}`;
    return axios.get(url, TUKConfig);
  },
  workerStatesGetByWorkflowIDNearby(workflowID, coords) {
    var url = API + `worker_states?workflow_id=${workflowID}&coords=${coords}`;
    return axios.get(url, TUKConfig);
  },
  workerStatesGetByWorkflowID(workflowID) {
    var url = API + `worker_states?workflow_id=${workflowID}`;
    return axios.get(url, TUKConfig);
  },
  workerStatesGetByWorkflowType(workflowTypeName) {
    var url = API + `worker_states?workflow_type_name=${workflowTypeName}`;
    return axios.get(url, TUKConfig);
  },
  versionGet() {
    var url = API + `version`;
    return axios.get(url, TUKConfig);
  },
  getDriverRemitTransactionForDate(userID, date) {
    var url = API + `remit?driver=${userID}&date=${date}`;
    return axios.get(url, TUKConfig);
  },
  analyticsGetDriverWalletData(userID) {
    var url = API + `analytics?driver_wallet=${userID}`;
    return axios.get(tsAdd(url), TUKConfig);
  },
  analyticsGetDriverHistory(userID) {
    var url = API + `analytics?driver_history=${userID}`;
    return axios.get(tsAdd(url), TUKConfig);
  },
  analyticsGetDispatcherHistory(workflowID) {
    var url = API + `analytics?dispatcher_history=${workflowID}`;
    return axios.get(url, TUKConfig);
  },
  analyticsGetRideCount(userID) {
    var url = API + `analytics?ride_count=${userID}`;
    return axios.get(url, TUKConfig);
  },
  analyticsGetCommerceOrderCount(workflowID, userID) {
    var url =
      API +
      `analytics/commerce_order_count?user=${userID}&workflow=${workflowID}`;
    return axios.get(url, TUKConfig);
  },
  lalamoveGetQuote(data) {
    var url = API + `lalamove/get_quote`;
    return axios.post(url, data, TUKConfig);
  },
  getClosestDeliveryDrivers(transactionID) {
    var url =
      API + `helpers/get_closest_delivery_drivers?transaction=${transactionID}`;
    return axios.get(url, TUKConfig);
  },
  getPastAddressesByUserID(userID) {
    var url = API + `helpers/get_past_delivery_addresses?user_id=${userID}`;
    return axios.get(url, TUKConfig);
  },
  addTipToDelivery(data) {
    var url = API + `helpers/add_tip_to_delivery`;
    return axios.patch(url, data, TUKConfig);
  },
  addTukpayToDelivery(data) {
    var url = API + `helpers/add_tukpay_to_delivery`;
    return axios.patch(url, data, TUKConfig);
  },
  addTukDiscountToOrder(data) {
    var url = API + `helpers/add_tuk_discount_to_order`;
    return axios.patch(url, data, TUKConfig);
  },
  addServiceFeeAdjustmentToOrder(data) {
    var url = API + `helpers/add_service_fee_adjustment_to_order`;
    return axios.patch(url, data, TUKConfig);
  },
  retryLalamoveOrder(data) {
    var url = API + `helpers/retry_lalamove_order`;
    return axios.post(url, data, TUKConfig);
  },
  cancelLalamoveOrder(data) {
    var url = API + `helpers/cancel_lalamove_order`;
    return axios.patch(url, data, TUKConfig);
  },
  killLongRunningQueries() {
    var url = API + `helpers/kill_long_running`;
    return axios.get(url, TUKConfig);
  }
};

export default api;
